module.exports = __webpack_public_path__ + "img/definitive-semipublic.c47b832e.png";